import styled from 'styled-components'

export const TitleContainer = styled.div`
  text-align: center;
  margin-top: 80px;
`

export const Title = styled.h1`
  font-weight: 600;
  font-size: 48px;
  line-height: 100%;
  color: #2A2637;
`

export const PriceWrapp = styled.div`
  padding-top: 85px;
  
  @media (min-width: 980px) {
    padding-top: 36px;
  }
`